module.exports = __webpack_public_path__ + "img/dw-signature.9825c4ff.png";